import React from "react"
import Button from "@mui/material/Button"
import Modal from "@mui/material/Modal"
import makeStyles from "@mui/styles/makeStyles"
import { COLORS } from "../../../utils"

const useStyles = makeStyles({
    modal: {
        position: "absolute",
        width: 438,
        minHeight: 183,
        background: COLORS.WHITE,
        textAlign: "justify",
        color: COLORS.BLACK,
        padding: "40px 30px",
        fontSize: 16,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    actions: {
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: 15,
        marginBottom: 10
    },
    title: {
        fontWeight: 500,
        fontSize: 15,
        lineHeight: "24px",
        paddingBottom: 15
    },
    text: {
        fontSize: 12
    },
    firstButton: {
        marginRight: 10,
    }
})

const BackModal = (props) => {
    const {
        goBack,
        onClose,
        open
    } = props

    const classes = useStyles()

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div className={classes.modal}>
                <div className={classes.title}>
                    Voulez-vous recommencez la réception de cet article ?
                </div>
                <div className={classes.text}>
                    Tous les lots et avoirs générés pour cette référence seront supprimés.
                </div>
                <div className={classes.actions}>
                    <Button
                        color="primary"
                        onClick={goBack}
                        variant="outlined"
                        className={classes.firstButton}
                    >
                        Recommencer
                    </Button>
                    <Button
                        color="primary"
                        type="submit"
                        onClick={onClose}
                        variant="contained"
                    >
                        Annuler
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default BackModal
